module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/banner_a13a99706fb8aeaa701c1b0f1556c900.png";